import React from 'react';
import { getUsername } from '../../utils/widget-facade';
import { detectCredentialType } from '../../utils/user-utils';

interface AthenaConnectUserIdentifierProps {
  identifier?: string;
}

export default function AthenaConnectUserIdentifier({ identifier }: Readonly<AthenaConnectUserIdentifierProps>) {
  const transformedUsername = identifier || getUsername();
  const credentialType = detectCredentialType(transformedUsername);
  const isEmail = credentialType === 'email';
  const label = isEmail ? 'Email' : 'athenaOne username';
  const displayValue = isEmail ? transformedUsername : transformedUsername.split('@')[0];

  return (
    <div className="o-form-fieldset o-form-label-top">
      <div className="okta-form-label o-form-label">
        <label>{label}</label>
      </div>
      <div className="o-form-input">
        <strong>{displayValue}</strong>
      </div>
    </div>
  );
}
